import axios from 'axios';

const updateProducts = function (productTypeId, productSelect) {
  axios
    .get('/products_by_product_type', {
      params: { product_type_id: productTypeId },
    })
    .then(response => {
      productSelect.empty();
      $.each(response.data, function (_, product) {
        productSelect.append(
          $('<option>', {
            text: product.code_and_name,
            value: product.id,
          })
        );
      });
      productSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  // ticket_transactions report
  $('#product-types-select-1').select2({
    placeholder: 'Buscar un tipo de producto',
    width: '100%',
  });
  $('#products-select-1').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#product-lots-select-1').select2({
    placeholder: 'Código de lote',
    width: '100%',
    tags: true,
    tokenSeparators: [',', ' '],
  });
  $('#product-lots-select-2').select2({
    placeholder: 'Código de lote',
    width: '100%',
    tags: true,
    tokenSeparators: [',', ' '],
  });
  $(
    '#by-ticket-order, #by-ticket-type, #by-ticket-client, #by-ticket-address, #by-ticket-owner, #by-ticket-driver, #by-ticket-transport-company, #by-ticket-truck, #by-ticket-ship'
  ).hide();
  $('#by-ticket-order-check').on('click', function () {
    $('#by-ticket-order').toggle(this.checked);
  });
  $('#by-ticket-type-check').on('click', function () {
    $('#by-ticket-type').toggle(this.checked);
  });
  $('#by-ticket-client-check').on('click', function () {
    $('#by-ticket-client').toggle(this.checked);
  });
  $('#by-ticket-address-check').on('click', function () {
    $('#by-ticket-address').toggle(this.checked);
  });
  $('#by-ticket-owner-check').on('click', function () {
    $('#by-ticket-owner').toggle(this.checked);
  });
  $('#by-ticket-driver-check').on('click', function () {
    $('#by-ticket-driver').toggle(this.checked);
  });
  $('#by-ticket-transport-company-check').on('click', function () {
    $('#by-ticket-transport-company').toggle(this.checked);
  });
  $('#by-ticket-truck-check').on('click', function () {
    $('#by-ticket-truck').toggle(this.checked);
  });
  $('#by-ticket-ship-check').on('click', function () {
    $('#by-ticket-ship').toggle(this.checked);
  });
  $('#by-ticket-product-type-check').on('change', function () {
    const byProductType = $('#by-ticket-product-type-check').is(':checked');
    $('.by-ticket-product-type').toggleClass('d-none', !byProductType);
  });
  $('#by-ticket-product-check').on('change', function () {
    const byProduct = $('#by-ticket-product-check').prop('checked');
    $('.by-ticket-product').toggleClass('d-none', !byProduct);
  });
  $('#product-types-select-1').on('change', function () {
    updateProducts(this.value, $('#products-select-1'));
  });

  // ticket_transactions_summary report
  $('#product-types-select-2').select2({
    placeholder: 'Buscar un tipo de producto',
    width: '100%',
  });
  $('#products-select-2').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#by-ticket-type-2, #by-ticket-client-2, #by-ticket-owner-2').hide();
  $('#by-ticket-type-check-2').on('click', function () {
    $('#by-ticket-type-2').toggle(this.checked);
  });
  $('#by-ticket-client-check-2').on('click', function () {
    $('#by-ticket-client-2').toggle(this.checked);
  });
  $('#by-ticket-owner-check-2').on('click', function () {
    $('#by-ticket-owner-2').toggle(this.checked);
  });
  $('#by-ticket-product-type-check-2').on('change', function () {
    let byProductType = $('#by-ticket-product-type-check-2').is(':checked');
    $('.by-ticket-product-type-2').toggleClass('d-none', !byProductType);
  });
  $('#by-ticket-product-check-2').on('change', function () {
    let byProduct = $('#by-ticket-product-check-2').prop('checked');
    $('.by-ticket-product-2').toggleClass('d-none', !byProduct);
  });
  $('#product-types-select-2').on('change', function () {
    updateProducts(this.value, $('#products-select-2'));
  });
  $('#by-ticket-product-lot-check-1').on('change', function () {
    let byProductLot = $('#by-ticket-product-lot-check-1').prop('checked');
    $('.by-ticket-product-lot-1').toggleClass('d-none', !byProductLot);
  });
  $('#by-ticket-product-lot-check-2').on('change', function () {
    let byProductLot = $('#by-ticket-product-lot-check-2').prop('checked');
    $('.by-ticket-product-lot-2').toggleClass('d-none', !byProductLot);
  });
});
